import { Tab } from "@blueprintjs/core";
import { useApiEffect } from "nsitools-react";
import * as React from "react";
import { useHistory, useParams } from "react-router-dom";

import { StatutSocialDetailPage } from "..";
import { StatutSocialApi } from "../../../../../api";
import { ERoutes } from "../../../../../AppRouter";
import { BackButton, PageBase, ProtectedTabs } from "../../../../../components";
import { useApiService, useTl } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";

interface IStatutSocialItemPageProps {}

export const StatutSocialItemPage: React.FunctionComponent<IStatutSocialItemPageProps> = () => {
  const { t } = useTl();
  const { id, tab, state = "edit" } = useParams<{ id: string; tab: string; state: string }>();
  const idStatut = React.useMemo(() => +id, [id]);
  const history = useHistory();

  const statutSocialApi = useApiService(StatutSocialApi);
  const [displayName] = useApiEffect(() => statutSocialApi.statutSocialGetDisplayName({ id: +id }), [id]);

  return (
    <PageBase
      breadCrumbs={[
        { text: t(ETLCodes.StatutsSociaux), route: ERoutes.statutSocial },
        { text: +id <= 0 ? t(ETLCodes.New) : displayName }
      ]}
    >
      <ProtectedTabs
        id="TabsCentre"
        onChange={newTabId => history.push(`${ERoutes.statutSocial}/${id}/${newTabId}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.statutSocial}></BackButton>
        <Tab
          id="detail"
          title={t(ETLCodes.Detail)}
          panel={<StatutSocialDetailPage idStatut={idStatut} editMode={state === "edit"} />}
        />
      </ProtectedTabs>
    </PageBase>
  );
};
